import React, { useEffect, useState } from "react";
import Styles from "./UploadDocModal.module.css";
import { Modal } from "@mui/material";
import { Close } from "@mui/icons-material";
import {
  acceptRejectAgreement,
  generateFaDocument,
  generateLoaDocument,
  generateLoiDocument,
  getDocumentUrlByLedgerId,
  uploadFaFile,
  uploadLedgerFile,
  uploadLoaFile,
  uploadLoiFile,
} from "../../../../Services/ApiCalling/banking";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchActiveLedger,
  fetchViewDocumentHistory,
  fetchMatchmakingResults,
  fetchAllBankingListings,
} from "../../../../Redux/Slices/bankingSlice";
import { ReactComponent as ViewIcon } from "../../../../assets/images/view.svg";
import { ReactComponent as UploadIcon } from "../../../../assets/images/uploadIcon.svg";
import { ReactComponent as ViewUploadFile } from "../../../../assets/images/viewUploadFile.svg";
import { ReactComponent as CrossIcon } from "../../../../assets/images/circlex.svg";
import { ReactComponent as Cross } from "../../../../assets/images/circlered.svg";
import { ReactComponent as Check } from "../../../../assets/images/right.svg";
import { ReactComponent as DownloadIcon } from "../../../../assets/images/downloadFile.svg";
import SuccessPop from "../../../../commons/PopupModal/BankingPopup/SuccessPop/SuccessPop";
import PreviewModal from "../../../../commons/PreviewModal/PreviewModal";
import ConfirmationModal from "../../../../commons/ConfirmationModal/ConfirmationModal";

const UploadDocModal = ({
  open,
  handleClose,
  connectionId,
  onAllDocsUploaded,
  agreementStatus,
  isCounterparty,
  upData,
  activeCounterparty,
  onRefresh,
}) => {
  const dispatch = useDispatch();

  const listingId = upData?.[0]?.selfListing?.id;

  const { documentViewHistory, loading, error } = useSelector(
    (state) => state.bankingSlice,
  );

  const [selectedFileName, setSelectedFileName] = useState("");
  const [selectedFileNameLoa, setSelectedFileNameLoa] = useState("");
  const [selectedFileNameOther, setSelectedFileNameOther] = useState("");
  const [selectedFileNameFa, setSelectedFileNameFa] = useState("");

  const [selectedLoiFile, setSelectedLoiFile] = useState(null);
  const [selectedLoaFile, setSelectedLoaFile] = useState(null);
  const [selectedFaFile, setSelectedFaFile] = useState(null);
  const [selectedOtherFile, setSelectedOtherFile] = useState(null);

  const [uploadedLoiId, setUploadedLoiId] = useState(null);
  const [uploadedLoaId, setUploadedLoaId] = useState(null);
  const [uploadedFaId, setUploadedFaId] = useState(null);
  const [uploadedOtherId, setUploadedOtherId] = useState(null);

  const [uploading, setUploading] = useState(false);
  const [otherDocUploading, setOtherDocUploading] = useState(false);
  const [approvalLoading, setApprovalLoading] = useState(false);

  const [successPopupOpen, setSuccessPopupOpen] = useState(false);
  const [previewModal, setPreviewModal] = useState(false);
  const [previewFileUrl, setPreviewFileUrl] = useState(null);
  const [previewDocumentId, setPreviewDocumentId] = useState(null);
  const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);
  const [rejectionModalOpen, setRejectionModalOpen] = useState(false);
  const [hasJustUploaded, setHasJustUploaded] = useState(false);

  const [comments, setComments] = useState("");
  const [finalAgreementError, setFinalAgreementError] = useState("");

  const [filterTab, setFilterTab] = useState("LOI");
  const [documentType, setDocumentType] = useState("LOI");

  const [latestFormData, setLatestFormData] = useState(null);

  const [confirmModal, setConfirmModal] = useState({
    value: false,
    type: "",
    data: "",
    header: "",
  });

  const [hasCounterpartyUploadedDoc, setHasCounterpartyUploadedDoc] =
    useState(false);

  const [dataFetched, setDataFetched] = useState(false);

  const isFirstParty = !isCounterparty;

  const showApprovalButtons =
    agreementStatus?.toUpperCase() === "UPLOADED" && isCounterparty;

  const shouldEnableUploads =
    agreementStatus?.toUpperCase() === "NOT_UPLOADED" || showApprovalButtons;

  const finalAgreementUploadedOrEditing =
    isFirstParty &&
    (selectedFileNameFa ||
      activeCounterparty?.agreementDocumentHistory?.length > 0);

  const shouldDisableUploads = showApprovalButtons;

  const isLoiDisabled =
    (shouldDisableUploads && !isCounterparty) ||
    (isCounterparty && !shouldEnableUploads && !showApprovalButtons) ||
    (!isCounterparty && finalAgreementUploadedOrEditing);

  const isLoaDisabled =
    (shouldDisableUploads && !isCounterparty) ||
    (isCounterparty && !shouldEnableUploads && !showApprovalButtons) ||
    (!isCounterparty && finalAgreementUploadedOrEditing);

  const isOtherDocumentsDisabled =
    (shouldDisableUploads && !isCounterparty) ||
    (isCounterparty && !shouldEnableUploads && !showApprovalButtons) ||
    (!isCounterparty && finalAgreementUploadedOrEditing);

  const isFinalAgreementDisabled =
    (shouldDisableUploads && !isFirstParty && !showApprovalButtons) ||
    (isCounterparty && !shouldEnableUploads && !showApprovalButtons);
  useEffect(() => {
    if (!open) {
      setHasJustUploaded(false);
    }
  }, [open]);

  const handleConfirmModal = ({ type, data, header }) => {
    setConfirmModal({
      value: true,
      type,
      data,
      header,
    });
  };

  const handleGenerateLoaDoc = async () => {
    if (!connectionId) return;
    try {
      const response = await generateLoaDocument(connectionId);
      const blob = response.data;
      const url = window.URL.createObjectURL(
        new Blob([blob], {
          type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        }),
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Letter_of_Award.docx");
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      toast.success("LOA document generated and downloaded successfully!");
    } catch (error) {
      toast.error(
        error?.response?.data?.message || "Failed to generate LOA document.",
      );
    }
  };

  const handleGenerateLoiDoc = async () => {
    if (!connectionId) return;
    try {
      const response = await generateLoiDocument(connectionId);
      const blob = response.data;
      const url = window.URL.createObjectURL(
        new Blob([blob], {
          type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        }),
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Letter_of_Intent.docx");
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      toast.success("LOI document generated and downloaded successfully!");
    } catch (error) {
      console.error("Error generating LOI:", error);
      toast.error(
        error?.response?.data?.message || "Failed to generate LOI document.",
      );
    }
  };

  const handleGenerateFinalAgreementDoc = async () => {
    if (!connectionId) return;
    try {
      const response = await generateLoaDocument(connectionId);
      const blob = response.data;
      const url = window.URL.createObjectURL(
        new Blob([blob], {
          type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        }),
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Final_Agreement.docx");
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      toast.success(
        "Final Agreement document generated and downloaded successfully!",
      );
    } catch (error) {
      console.error("Error generating Final Agreement:", error);
      toast.error(
        error?.response?.data?.message ||
          "Failed to generate Final Agreement document.",
      );
    }
  };

  const handleGenerateFaDoc = async () => {
    if (!connectionId) return;
    try {
      const response = await generateFaDocument(connectionId);
      const blob = response.data;
      const url = window.URL.createObjectURL(
        new Blob([blob], {
          type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        }),
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Final_Agreement.docx");
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      toast.success(
        "Final Agreement document generated and downloaded successfully!",
      );
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          "Failed to generate Final Agreement DOCX.",
      );
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const inputName = e.target.name;

    if (file.type !== "application/pdf") {
      toast.error("Only **PDF** files are supported.");
      e.target.value = "";
      return;
    }

    if (inputName === "fileUpload") {
      setSelectedFileName(file.name);
      setSelectedLoiFile(file);
      setHasJustUploaded(true);
      handleConfirmModal({
        type: "LOI",
        data: "Do you want to upload and share this document with the counterparty?",
        header: "LOI",
      });
    } else if (inputName === "fileUploadLoa") {
      setSelectedFileNameLoa(file.name);
      setSelectedLoaFile(file);
      setHasJustUploaded(true);
      handleConfirmModal({
        type: "LOA",
        data: "Do you want to upload and share this document with the counterparty?",
        header: "LOA",
      });
    } else if (inputName === "fileUploadOther") {
      setSelectedFileNameOther(file.name);
      setSelectedOtherFile(file);
      setHasJustUploaded(true);
      handleConfirmModal({
        type: "OTHER",
        data: "Do you want to upload and share this document with the counterparty?",
        header: "OTHER",
      });
    } else if (inputName === "fileUploadFa") {
      setSelectedFileNameFa(file.name);
      setSelectedFaFile(file);
      setFinalAgreementError("");
      setHasJustUploaded(true);
      handleConfirmModal({
        type: "FA",
        data: showApprovalButtons
          ? "Do you want to upload and share this document with the counterparty?"
          : "Do you want to submit the final agreement for approval by the counterparty?",
        header: "AGREEMENT",
      });
    }
  };

  const handleLoiSubmit = async () => {
    if (!selectedLoiFile || !connectionId) {
      toast.info("Please select a LOI file before submitting.");
      return;
    }

    setUploading(true);
    const formData = new FormData();
    formData.append("file", selectedLoiFile);

    try {
      const response = await uploadLoiFile(formData, connectionId, listingId);
      if (response?.data?.id) {
        setUploadedLoiId(response.data.id);
        setHasJustUploaded(true);

        await dispatch(fetchViewDocumentHistory(connectionId));

        if (onRefresh && typeof onRefresh === "function") {
          await onRefresh();
        }

        toast.success("LOI file uploaded successfully!");
      }

      setSelectedFileName("");
      setSelectedLoiFile(null);
      document.getElementById("fileUpload").value = "";
    } catch (err) {
      toast.error(
        err?.response?.data?.message || "LOI upload failed. Please try again.",
      );
    } finally {
      setUploading(false);
    }
  };

  const handleLoaSubmit = async () => {
    if (!selectedLoaFile || !connectionId) {
      toast.info("Please select a LOA file before submitting.");
      return;
    }

    setUploading(true);
    const formData = new FormData();
    formData.append("file", selectedLoaFile);

    try {
      const response = await uploadLoaFile(formData, connectionId, listingId);
      if (response?.data?.id) {
        setUploadedLoaId(response.data.id);
        setHasJustUploaded(true);

        await dispatch(fetchViewDocumentHistory(connectionId));

        if (onRefresh && typeof onRefresh === "function") {
          await onRefresh();
        }

        toast.success("LOA file uploaded successfully!");
      }

      setSelectedFileNameLoa("");
      setSelectedLoaFile(null);
      document.getElementById("fileUploadLoa").value = "";
    } catch (err) {
      toast.error(
        err?.response?.data?.message || "LOA upload failed. Please try again.",
      );
    } finally {
      setUploading(false);
    }
  };

  const handleFaSubmit = async () => {
    if (!selectedFaFile || !connectionId) {
      toast.info("Please select a Final Agreement file before submitting.");
      return;
    }

    setUploading(true);
    const formData = new FormData();
    formData.append("file", selectedFaFile);

    try {
      const response = await uploadFaFile(formData, connectionId, listingId);

      if (response?.data?.id) {
        setUploadedFaId(response.data.id);
        setHasJustUploaded(true);

        await dispatch(fetchViewDocumentHistory(connectionId));

        if (onRefresh && typeof onRefresh === "function") {
          await onRefresh();
        }

        toast.success("Final Agreement uploaded successfully!");
      }

      setSelectedFileNameFa("");
      setSelectedFaFile(null);
      document.getElementById("fileUploadFa").value = "";
      setFinalAgreementError("");
    } catch (err) {
      toast.error(
        err?.response?.data?.message ||
          "Final Agreement upload failed. Please try again.",
      );
    } finally {
      setUploading(false);
    }
  };

  const handleApproveClick = async () => {
    if (!connectionId) {
      toast.error("Connection ID is missing.");
      return;
    }

    setConfirmationModalOpen(true);
  };

  // Update handleConfirmApproval
  const handleConfirmApproval = async () => {
    const currentUserParty = getCurrentUserParty();

    let currentPartyDocIds;

    if (currentUserParty === "INITIATOR") {
      currentPartyDocIds = {
        loiDocId: activeCounterparty?.partyOneLoiDocumentId,
        loaDocId: activeCounterparty?.partyOneLoaDocumentId,
        agreementDocId: activeCounterparty?.partyOneAgreementDocumentId,
      };
    } else if (currentUserParty === "ACCEPTOR") {
      currentPartyDocIds = {
        loiDocId: activeCounterparty?.partyTwoLoiDocumentId,
        loaDocId: activeCounterparty?.partyTwoLoaDocumentId,
        agreementDocId: activeCounterparty?.partyTwoAgreementDocumentId,
      };
    }

    const hasAnyUploadedDoc = !!(
      currentPartyDocIds?.loiDocId ||
      currentPartyDocIds?.loaDocId ||
      currentPartyDocIds?.agreementDocId
    );

    const hasSelectedFile = !!(
      selectedLoiFile ||
      selectedLoaFile ||
      selectedFaFile
    );

    const hasUploadedInSession = !!(
      uploadedLoiId ||
      uploadedLoaId ||
      uploadedFaId ||
      uploadedOtherId
    );

    if (!hasSelectedFile && !hasUploadedInSession && !hasAnyUploadedDoc) {
      toast.info("Please upload at least one document before submitting.");
      return;
    }

    setConfirmationModalOpen(false);
    setApprovalLoading(true);

    try {
      await acceptRejectAgreement(connectionId, 1);

      handleClose();
      setSuccessPopupOpen(true);
      if (typeof onAllDocsUploaded === "function") {
        onAllDocsUploaded();
      }

      if (listingId) {
        dispatch(fetchMatchmakingResults({ id: listingId }));
      }
      dispatch(fetchAllBankingListings());

      setTimeout(() => {
        window.location.reload();
      }, 4000);
    } catch (error) {
      toast.error(
        error?.response?.data?.message || "Failed to approve agreement.",
      );
    } finally {
      setApprovalLoading(false);
    }
  };
  const handleRejectClick = async () => {
    if (!connectionId) {
      toast.error("Connection ID is missing.");
      return;
    }

    setRejectionModalOpen(true);
  };

  const handleConfirmRejection = async () => {
    setRejectionModalOpen(false);
    setApprovalLoading(true);
    try {
      await acceptRejectAgreement(connectionId, 0);
      handleClose();
      if (typeof onAllDocsUploaded === "function") {
        onAllDocsUploaded();
      }

      if (listingId) {
        dispatch(fetchMatchmakingResults({ id: listingId }));
      }
      dispatch(fetchAllBankingListings());

      setTimeout(() => {
        window.location.reload();
      }, 4000);
    } catch (error) {
      toast.error(
        error?.response?.data?.message || "Failed to reject agreement.",
      );
    } finally {
      setApprovalLoading(false);
    }
  };

  const handleLoiConfirm = async () => {
    setConfirmModal({
      value: false,
      type: "",
      data: "",
      header: "",
    });

    if (selectedLoiFile) {
      try {
        const formData = new FormData();
        formData.append("file", selectedLoiFile);
        setLatestFormData(formData);
        const response = await uploadLoiFile(formData, connectionId, listingId);

        if (response?.data?.id) {
          setUploadedLoiId(response.data.id);
          setHasJustUploaded(true); // Set it here after successful upload
          toast.success("LOI file uploaded successfully!");
        }
        await dispatch(fetchViewDocumentHistory(connectionId));
        if (typeof onRefresh === "function") await onRefresh();
      } catch (error) {
        toast.error(error?.response?.data?.message || "LOI upload failed.");
      }
    } else {
      toast.success("LOI confirmed for upload! Click 'Submit' to finalize.");
    }
  };

  const handleLoaConfirm = async () => {
    setConfirmModal({
      value: false,
      type: "",
      data: "",
      header: "",
    });

    if (selectedLoaFile) {
      try {
        const formData = new FormData();
        formData.append("file", selectedLoaFile);
        setLatestFormData(formData);
        const [loaResponse, faResponse] = await Promise.all([
          uploadLoaFile(formData, connectionId, listingId),
        ]);
        if (loaResponse?.data?.id) {
          setUploadedLoaId(loaResponse.data.id);
          setHasJustUploaded(true); // Set it here after successful upload
          toast.success("LOA file uploaded successfully!");
        }
        if (faResponse?.data?.id) {
          setUploadedFaId(faResponse.data.id);
        }
        await dispatch(fetchViewDocumentHistory(connectionId));
        if (typeof onRefresh === "function") await onRefresh();
      } catch (error) {
        toast.error(error?.response?.data?.message || "LOA upload failed.");
      }
    } else {
      toast.success("LOA confirmed for upload! Click 'Submit' to finalize.");
    }
  };

  const handleFaConfirm = async () => {
    setConfirmModal({
      value: false,
      type: "",
      data: "",
      header: "",
    });

    if (selectedFaFile) {
      try {
        const formData = new FormData();
        formData.append("file", selectedFaFile);
        const response = await uploadFaFile(formData, connectionId, listingId);
        if (response?.data?.id) {
          setUploadedFaId(response.data.id);
          setHasJustUploaded(true);
          toast.success("Final Agreement uploaded successfully!");
          if (isCounterparty) {
            setFilterTab("Final Agreement");
          }
        }
        await dispatch(fetchViewDocumentHistory(connectionId));
        if (typeof onRefresh === "function") await onRefresh();
        handleClose();
      } catch (error) {
        toast.error(
          error?.response?.data?.message || "Final Agreement upload failed.",
        );
      }
    } else {
      toast.success(
        "Final Agreement confirmed for upload! Click 'Submit' to finalize.",
      );
    }
  };

  const handleViewDoc = async (id) => {
    try {
      const response = await getDocumentUrlByLedgerId(id);
      const url = response.data;
      if (url) {
        setPreviewFileUrl(url);
        setPreviewDocumentId(id);
        setPreviewModal(true);
      } else {
        toast.error("Document URL not found");
      }
    } catch (err) {
      toast.error("Could not fetch document URL.");
    }
  };

  const handleViewLoiDoc = () => {
    if (uploadedLoiId) {
      handleViewDoc(uploadedLoiId);
    } else {
      const loiDocs = documentViewHistory
        ?.filter(
          (doc) =>
            doc.filename?.toLowerCase().includes("loi") ||
            doc.filename?.toLowerCase().includes("letter_of_intent") ||
            doc.documentType === "LOI",
        )
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      const loiDoc = loiDocs?.[0];
      if (loiDoc) {
        handleViewDoc(loiDoc.id);
      } else {
        toast.info("No LOI document has been uploaded yet.");
      }
    }
  };

  const handleViewLoaDoc = () => {
    if (uploadedLoaId) {
      handleViewDoc(uploadedLoaId);
    } else {
      const loaDocs = documentViewHistory
        ?.filter(
          (doc) =>
            doc.filename?.toLowerCase().includes("loa") ||
            doc.filename?.toLowerCase().includes("letter_of_agreement") ||
            doc.documentType === "LOA",
        )
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      const loaDoc = loaDocs?.[0];
      if (loaDoc) {
        handleViewDoc(loaDoc.id);
      } else {
        toast.info("No LOA document has been uploaded yet.");
      }
    }
  };

  const getLatestFinalAgreementDoc = () => {
    if (documentViewHistory && documentViewHistory.length > 0) {
      const faDocs = documentViewHistory
        ?.filter(
          (doc) =>
            doc.documentType === "AGREEMENT" ||
            doc.documentType === "FA" ||
            doc.filename?.toLowerCase().includes("final") ||
            doc.filename?.toLowerCase().includes("agreement") ||
            doc.filename?.toLowerCase().includes("fa"),
        )
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

      return faDocs?.[0] || null;
    }
    return null;
  };

  const handleViewFaDoc = () => {
    if (uploadedFaId) {
      handleViewDoc(uploadedFaId);
      return;
    }

    if (documentViewHistory && documentViewHistory.length > 0) {
      const faDocs = documentViewHistory
        ?.filter(
          (doc) =>
            doc.documentType === "AGREEMENT" ||
            doc.documentType === "FA" ||
            doc.filename?.toLowerCase().includes("final") ||
            doc.filename?.toLowerCase().includes("agreement") ||
            doc.filename?.toLowerCase().includes("fa") ||
            (selectedFileNameFa && doc.filename === selectedFileNameFa),
        )
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

      const faDoc = faDocs?.[0];
      if (faDoc) {
        handleViewDoc(faDoc.id);
      } else {
        if (selectedFileNameFa) {
          toast.error(
            "Could not find the uploaded Final Agreement document. Please try refreshing.",
          );
        } else {
          toast.info("No Final Agreement document has been uploaded yet.");
        }
      }
    } else {
      toast.info("No documents found in history.");
    }
  };

  const handleViewOtherDoc = () => {
    if (uploadedOtherId) {
      handleViewDoc(uploadedOtherId);
    } else {
      const otherDoc = documentViewHistory
        ?.filter(
          (doc) =>
            doc.documentType === "OTHER" ||
            (!doc.filename?.toLowerCase().includes("loi") &&
              !doc.filename?.toLowerCase().includes("loa") &&
              !doc.filename?.toLowerCase().includes("final_agreement") &&
              !doc.documentType === "AGREEMENT" &&
              !doc.documentType === "LOI" &&
              !doc.documentType === "LOA"),
        )
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

      const latestOtherDoc = otherDoc?.[0];

      if (latestOtherDoc) {
        handleViewDoc(latestOtherDoc.id);
      } else {
        toast.info("No other document has been uploaded yet.");
      }
    }
  };

  const handleClosePreview = () => {
    setPreviewModal(false);
    setPreviewFileUrl(null);
    setPreviewDocumentId(null);
  };

  const handleDownloadDocument = async (docId, filename) => {
    try {
      const response = await getDocumentUrlByLedgerId(docId);
      const url = response.data;
      if (url) {
        const link = document.createElement("a");
        link.href = url;
        link.download = filename || "document.pdf";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        toast.success("Document downloaded successfully!");
      } else {
        toast.error("Could not fetch document URL");
      }
    } catch (err) {
      toast.error("Failed to download document. Please try again.");
    }
  };

  const handleCommentsChange = (text) => {
    const words = text.trim().split(/\s+/);
    if (words.length <= 50) {
      setComments(text);
    } else {
      const limitedText = words.slice(0, 50).join(" ");
      setComments(limitedText);
      toast.info("Comments limited to 50 words.");
    }
  };

  const handleOtherDocument = async (
    triggeredByUploadButton = false,
    commentArg = null,
  ) => {
    const effectiveComments = commentArg ?? comments;

    if (!selectedOtherFile && !effectiveComments?.trim()) {
      toast.info("Please select a file or add a comment before uploading.");
      return;
    }

    setOtherDocUploading(true);
    const formData = new FormData();
    if (selectedOtherFile) {
      formData.append("file", selectedOtherFile);
    }
    if (effectiveComments) {
      formData.append("comments", effectiveComments);
    }

    try {
      const response = await uploadLedgerFile(
        formData,
        connectionId,
        listingId,
        comments.trim(),
      );

      if (response?.data?.id) {
        setUploadedOtherId(response.data.id);
        setHasJustUploaded(true); // Set it here after successful upload

        await dispatch(fetchViewDocumentHistory(connectionId));

        if (onRefresh && typeof onRefresh === "function") {
          await onRefresh();
        }

        toast.success("Document uploaded successfully!");
      }

      setSelectedFileNameOther("");
      setSelectedOtherFile(null);
      setComments("");
      await dispatch(fetchViewDocumentHistory(connectionId));
      if (document.getElementById("fileUploadOther")) {
        document.getElementById("fileUploadOther").value = "";
      }
    } catch (err) {
      toast.error(
        err?.response?.data?.message ||
          "Other document upload failed. Please try again.",
      );
    } finally {
      setOtherDocUploading(false);
      setConfirmModal(false);
    }
  };

  const getLatestUserDocument = React.useCallback(() => {
    if (!Array.isArray(documentViewHistory) || documentViewHistory.length === 0)
      return null;

    const partyDocIds = isCounterparty
      ? [
          activeCounterparty?.partyOneLoiDocumentId,
          activeCounterparty?.partyOneLoaDocumentId,
          activeCounterparty?.partyOneAgreementDocumentId,
        ]
      : [
          activeCounterparty?.partyTwoLoiDocumentId,
          activeCounterparty?.partyTwoLoaDocumentId,
          activeCounterparty?.partyTwoAgreementDocumentId,
        ];

    const validIds = partyDocIds.filter(Boolean);
    const userDocs =
      validIds.length > 0
        ? documentViewHistory.filter((doc) => validIds.includes(doc.id))
        : documentViewHistory;

    return userDocs
      .slice()
      .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))[0];
  }, [
    documentViewHistory,
    isCounterparty,
    activeCounterparty?.partyOneLoiDocumentId,
    activeCounterparty?.partyOneLoaDocumentId,
    activeCounterparty?.partyOneAgreementDocumentId,
    activeCounterparty?.partyTwoLoiDocumentId,
    activeCounterparty?.partyTwoLoaDocumentId,
    activeCounterparty?.partyTwoAgreementDocumentId,
  ]);

  const fetchLatestUserDocumentFile = React.useCallback(async () => {
    const latestDoc = getLatestUserDocument();
    if (!latestDoc) return null;

    try {
      const urlResponse = await getDocumentUrlByLedgerId(latestDoc.id);
      const fileUrl = urlResponse?.data;
      if (!fileUrl) return null;

      const fileResponse = await fetch(fileUrl);
      const blob = await fileResponse.blob();
      const filename = latestDoc.filename || "document.pdf";
      const type = blob.type || "application/pdf";
      return new File([blob], filename, { type });
    } catch (err) {
      console.error("Failed to fetch latest user document for submit", err);
      return null;
    }
  }, [getLatestUserDocument]);

  const handleDocSubmit = async () => {
    const hasSelectedFiles =
      selectedLoiFile || selectedLoaFile || selectedFaFile;

    if (!hasSelectedFiles) {
      toast.info("Please select at least one document before submitting.");
      return;
    }
    setFinalAgreementError("");

    setUploading(true);
    const uploadPromises = [];
    const successMessages = [];

    try {
      if (selectedLoiFile) {
        const formData = new FormData();
        formData.append("file", selectedLoiFile);
        uploadPromises.push(
          uploadLoiFile(formData, connectionId, listingId).then((response) => {
            if (response?.data?.id) {
              setUploadedLoiId(response.data.id);
              successMessages.push("LOI file uploaded successfully!");
            }
            return response;
          }),
        );
      }

      if (selectedLoaFile) {
        const formData = new FormData();
        formData.append("file", selectedLoaFile);
        uploadPromises.push(
          Promise.all([
            uploadLoaFile(formData, connectionId, listingId),
            uploadLoaFile(formData, connectionId, listingId),
          ]).then(([loaResponse, faResponse]) => {
            if (loaResponse?.data?.id) {
              setUploadedLoaId(loaResponse.data.id);
              successMessages.push("LOA file uploaded successfully!");
            }
            if (faResponse?.data?.id) {
              setUploadedFaId(faResponse.data.id);
            }
            return loaResponse;
          }),
        );
      }

      if (selectedFaFile) {
        const formData = new FormData();
        formData.append("file", selectedFaFile);
        uploadPromises.push(
          uploadFaFile(formData, connectionId, listingId).then((response) => {
            if (response?.data?.id) {
              setUploadedFaId(response.data.id);
              successMessages.push("Final Agreement uploaded successfully!");
              if (isCounterparty) {
                setFilterTab("Final Agreement");
              }
            }
            return response;
          }),
        );
      }

      await Promise.all(uploadPromises);

      successMessages.forEach((message) => toast.success(message));

      // Reset main document state only
      setSelectedFileName("");
      setSelectedFileNameLoa("");
      setSelectedFileNameFa("");
      setSelectedLoiFile(null);
      setSelectedLoaFile(null);
      setSelectedFaFile(null);

      // Reset file inputs for main documents
      const fileInputs = ["fileUpload", "fileUploadLoa", "fileUploadFa"];
      fileInputs.forEach((inputId) => {
        const element = document.getElementById(inputId);
        if (element) element.value = "";
      });

      try {
        await dispatch(fetchViewDocumentHistory(connectionId));
        await dispatch(
          fetchActiveLedger({
            currentPage: 0,
            size: 20,
            bankingListingId: listingId,
          }),
        );

        if (typeof onAllDocsUploaded === "function") onAllDocsUploaded();

        if (typeof onRefresh === "function") onRefresh();

        const hasMainDocuments = selectedLoaFile || selectedFaFile;
        const willShowApprovalButtons = isCounterparty && hasMainDocuments;

        if (!willShowApprovalButtons) {
          handleClose();
        }
      } catch (error) {
        console.error("Error fetching updated data after submit", error);
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message || "Upload failed. Please try again.",
      );
    } finally {
      setUploading(false);
    }
  };

  const handleDirectSubmit = async () => {
    setConfirmModal({
      value: false,
      type: "",
      data: "",
      header: "",
    });

    // Hardcoded check for uploaded documents
    const hasAnyUploadedDoc = isCounterparty
      ? !!(
          activeCounterparty?.partyTwoLoiDocumentId ||
          activeCounterparty?.partyTwoLoaDocumentId ||
          activeCounterparty?.partyTwoAgreementDocumentId
        )
      : !!(
          activeCounterparty?.partyOneLoiDocumentId ||
          activeCounterparty?.partyOneLoaDocumentId ||
          activeCounterparty?.partyOneAgreementDocumentId
        );

    // Check if user has selected any file in current session
    const hasSelectedFile = !!(
      selectedLoiFile ||
      selectedLoaFile ||
      selectedFaFile
    );

    // Check if user has uploaded any file in current session
    const hasUploadedInSession = !!(
      uploadedLoiId ||
      uploadedLoaId ||
      uploadedFaId ||
      uploadedOtherId
    );

    // If no selected file, no uploaded file in session, and no historical uploads
    if (!hasSelectedFile && !hasUploadedInSession && !hasAnyUploadedDoc) {
      toast.info("Please upload at least one document before submitting.");
      return;
    }

    let fileToSubmit = selectedLoiFile || selectedLoaFile;
    let usedHistoryFile = false;

    if (!fileToSubmit) {
      const latestUserFile = await fetchLatestUserDocumentFile();

      if (latestUserFile) {
        fileToSubmit = latestUserFile;
        usedHistoryFile = true;
      } else {
        toast.info("Please upload at least one document before submitting.");
        return;
      }
    }

    try {
      const formData =
        latestFormData instanceof FormData && !usedHistoryFile
          ? latestFormData
          : new FormData();
      formData.set("file", fileToSubmit);

      const response = await uploadFaFile(formData, connectionId, listingId);

      if (response?.data?.id) {
        setUploadedFaId(response.data.id);

        toast.success("Final Agreement uploaded successfully!");
        if (isCounterparty) {
          setFilterTab("Final Agreement");
        }
      }

      await dispatch(fetchViewDocumentHistory(connectionId));

      if (typeof onRefresh === "function") onRefresh();

      if (typeof onAllDocsUploaded === "function") onAllDocsUploaded();

      handleClose();
    } catch (error) {
      const fallbackMessage =
        error?.response?.data?.message ||
        "Please upload at least one document before submitting.";
      toast.error(fallbackMessage);
    }
  };

  // Add this helper function to determine current user's party
  const getCurrentUserParty = () => {
    if (!activeCounterparty) return null;

    // Check if current user is the initiator or acceptor
    const currentUserId = upData?.[0]?.selfListing?.userId;

    if (currentUserId === activeCounterparty.connectionInitiatorId) {
      return "INITIATOR"; // Party One
    } else if (currentUserId === activeCounterparty.connectionAcceptorId) {
      return "ACCEPTOR"; // Party Two
    }

    return null;
  };

  // Update hasUploadedAnyDocument useMemo
  const hasUploadedAnyDocument = React.useMemo(() => {
    if (!activeCounterparty) return false;

    const currentUserParty = getCurrentUserParty();

    // Determine which party's documents to check based on current user
    let currentPartyDocIds;

    if (currentUserParty === "INITIATOR") {
      // Current user is initiator (Party One), check Party One docs
      currentPartyDocIds = {
        loiDocId: activeCounterparty?.partyOneLoiDocumentId,
        loaDocId: activeCounterparty?.partyOneLoaDocumentId,
        agreementDocId: activeCounterparty?.partyOneAgreementDocumentId,
      };
    } else if (currentUserParty === "ACCEPTOR") {
      // Current user is acceptor (Party Two), check Party Two docs
      currentPartyDocIds = {
        loiDocId: activeCounterparty?.partyTwoLoiDocumentId,
        loaDocId: activeCounterparty?.partyTwoLoaDocumentId,
        agreementDocId: activeCounterparty?.partyTwoAgreementDocumentId,
      };
    } else {
      return false;
    }

    const hasUploadedFromAPI = !!(
      currentPartyDocIds.loiDocId ||
      currentPartyDocIds.loaDocId ||
      currentPartyDocIds.agreementDocId
    );

    // Also check uploaded IDs from current session
    const hasUploadedInSession = !!(
      uploadedLoiId ||
      uploadedLoaId ||
      uploadedFaId ||
      uploadedOtherId
    );

    return hasUploadedFromAPI || hasUploadedInSession || hasJustUploaded;
  }, [
    activeCounterparty,
    uploadedLoiId,
    uploadedLoaId,
    uploadedFaId,
    uploadedOtherId,
    upData,
    hasJustUploaded,
  ]);

  useEffect(() => {
    if (connectionId && open && !dataFetched) {
      dispatch(fetchViewDocumentHistory(connectionId)).then(() => {
        setDataFetched(true);
      });
    }
  }, [dispatch, connectionId, open, dataFetched]);

  useEffect(() => {
    if (isCounterparty && activeCounterparty) {
      const hasPartyTwoLoiDoc =
        activeCounterparty?.partyTwoLoiDocumentId ||
        activeCounterparty?.partyOneLoiDocumentId;
      const hasPartyTwoLoaDoc =
        activeCounterparty?.partyTwoLoaDocumentId ||
        activeCounterparty?.partyOneLoaDocumentId;
      const hasPartyTwoAgreementDoc =
        activeCounterparty?.partyTwoAgreementDocumentId ||
        activeCounterparty?.partyOneAgreementDocumentId;
      const hasUploadedDoc =
        hasPartyTwoLoiDoc || hasPartyTwoLoaDoc || hasPartyTwoAgreementDoc;
      setHasCounterpartyUploadedDoc(hasUploadedDoc);
    }
  }, [isCounterparty, activeCounterparty]);

  useEffect(() => {
    if (open) {
      if (showApprovalButtons) {
        setFilterTab("Final Agreement");
      } else {
        setFilterTab("LOI");
      }

      setSelectedFileName("");
      setSelectedFileNameLoa("");
      setSelectedFileNameOther("");
      setSelectedFileNameFa("");
      setSelectedLoiFile(null);
      setSelectedLoaFile(null);
      setSelectedFaFile(null);
      setSelectedOtherFile(null);
      setUploadedLoiId(null);
      setUploadedLoaId(null);
      setUploadedFaId(null);
      setUploadedOtherId(null);
      setComments("");
      setFinalAgreementError("");
      setDataFetched(false);
    }
  }, [open, isCounterparty, activeCounterparty, showApprovalButtons]);

  return (
    <>
      <SuccessPop
        open={successPopupOpen}
        handleClose={() => setSuccessPopupOpen(false)}
      />

      <Modal open={open} onClose={handleClose}>
        <div className={`popupModal ${Styles.createEditModalCont}`}>
          <div
            className={`display_flex_row modalHeading ${Styles.headingText}`}
          >
            <div className={Styles.upHead}>Generate and Upload Docs</div>
            <Close
              style={{ fontSize: "24px", color: "#777777", cursor: "pointer" }}
              onClick={handleClose}
            />
          </div>

          <div className={Styles.uploadDocMain}>
            {(!showApprovalButtons ||
              (isCounterparty &&
                documentViewHistory &&
                documentViewHistory.length > 0)) && (
              <div className={`${Styles.uploadFirstFiles}`}>
                {/* --- Letter of Intent (LOI) Section --- */}
                <div className={Styles.loiSection}>
                  <span>
                    Letter of Intent{" "}
                    <span
                      className={`${Styles.generateBtn} `}
                      onClick={handleGenerateLoiDoc}
                      style={{
                        cursor: "pointer",
                        opacity: 1,
                      }}
                    >
                      Generate
                    </span>
                  </span>
                  <span>
                    <label
                      htmlFor="fileUpload"
                      className={`${Styles.customUploadBox} `}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        pointerEvents: "auto",
                        opacity: 1,
                      }}
                    >
                      <span
                        style={{
                          cursor: selectedFileName ? "pointer" : "pointer",
                        }}
                        onClick={(e) => {
                          e.preventDefault();
                          if (selectedFileName) {
                            handleViewLoiDoc();
                          } else {
                            document.getElementById("fileUpload")?.click();
                          }
                        }}
                        aria-label={
                          selectedFileName
                            ? "View uploaded LOI document"
                            : "Upload Letter of Intent document"
                        }
                        role="button"
                      >
                        {selectedFileName ? <ViewUploadFile /> : <UploadIcon />}
                      </span>

                      <span
                        className={Styles.fileNameText}
                        style={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          maxWidth: "180px",
                        }}
                      >
                        {selectedFileName || "Upload Letter of Intent.pdf"}
                      </span>

                      {selectedFileName && (
                        <span
                          onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            setSelectedFileName("");
                            setSelectedLoiFile(null);
                            setUploadedLoiId(null);
                            document.getElementById("fileUpload").value = "";
                          }}
                          style={{ cursor: "pointer" }}
                          aria-label="Remove uploaded LOI document"
                          role="button"
                          title="Remove"
                        >
                          <CrossIcon />
                        </span>
                      )}
                    </label>
                    <input
                      type="file"
                      id="fileUpload"
                      name="fileUpload"
                      accept=".pdf"
                      className={Styles.hiddenFileInput}
                      onChange={handleFileChange}
                      // disabled={isLoiDisabled}
                    />
                  </span>
                </div>

                {/* --- Letter of Award (LOA) Section --- */}
                <div className={Styles.loiSection}>
                  <span>
                    Letter of Award{" "}
                    <span
                      className={`${Styles.generateBtn} `}
                      onClick={handleGenerateLoaDoc}
                      style={{
                        cursor: "pointer",
                        opacity: 1,
                      }}
                    >
                      Generate
                    </span>
                  </span>
                  <span>
                    <label
                      htmlFor="fileUploadLoa"
                      className={`${Styles.customUploadBox} `}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        pointerEvents: "auto",
                        opacity: 1,
                      }}
                    >
                      <span
                        style={{
                          cursor: selectedFileNameLoa ? "pointer" : "pointer",
                        }}
                        onClick={(e) => {
                          e.preventDefault();
                          if (selectedFileNameLoa) {
                            handleViewLoaDoc();
                          } else {
                            document.getElementById("fileUploadLoa")?.click();
                          }
                        }}
                        aria-label={
                          selectedFileNameLoa
                            ? "View uploaded LOA document"
                            : "Upload Letter of Award document"
                        }
                        role="button"
                      >
                        {selectedFileNameLoa ? (
                          <ViewUploadFile />
                        ) : (
                          <UploadIcon />
                        )}
                      </span>

                      <span
                        className={Styles.fileNameText}
                        style={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          maxWidth: "180px",
                        }}
                      >
                        {selectedFileNameLoa || "Upload Letter of Award.pdf"}
                      </span>

                      {selectedFileNameLoa && (
                        <span
                          onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            setSelectedFileNameLoa("");
                            setSelectedLoaFile(null);
                            setUploadedLoaId(null);
                            document.getElementById("fileUploadLoa").value = "";
                          }}
                          style={{ cursor: "pointer" }}
                          aria-label="Remove uploaded LOA document"
                          role="button"
                          title="Remove"
                        >
                          <CrossIcon />
                        </span>
                      )}
                    </label>
                    <input
                      type="file"
                      id="fileUploadLoa"
                      name="fileUploadLoa"
                      accept=".pdf"
                      className={Styles.hiddenFileInput}
                      onChange={handleFileChange}
                      // disabled={isLoaDisabled}
                    />
                  </span>
                </div>

                {/* --- Final Agreement (FA) Section --- */}
                <div className={Styles.loiSection}>
                  <span>
                    Final Agreement
                    <span
                      className={`${Styles.generateBtn} `}
                      onClick={
                        isFinalAgreementDisabled
                          ? undefined
                          : handleGenerateFaDoc
                      }
                      style={{
                        cursor: "pointer",
                        opacity: isFinalAgreementDisabled ? 0.6 : 1,
                      }}
                    >
                      Generate
                    </span>
                  </span>
                  <span>
                    <label
                      htmlFor="fileUploadFa"
                      className={`${Styles.customUploadBox}`}
                      style={{
                        pointerEvents: "auto",
                        opacity: 1,
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <span
                        style={{
                          cursor: !isFinalAgreementDisabled
                            ? "pointer"
                            : "default",
                        }}
                        onClick={(e) => {
                          e.preventDefault();
                          if (!isFinalAgreementDisabled) {
                            if (selectedFileNameFa) {
                              handleViewFaDoc();
                            } else {
                              document.getElementById("fileUploadFa")?.click();
                            }
                          }
                        }}
                        aria-label={
                          selectedFileNameFa && !isFinalAgreementDisabled
                            ? "View uploaded Final Agreement document"
                            : !isFinalAgreementDisabled
                              ? "Upload Final Agreement document"
                              : ""
                        }
                        role={!isFinalAgreementDisabled ? "button" : undefined}
                      >
                        {selectedFileNameFa ? (
                          <ViewUploadFile />
                        ) : (
                          <UploadIcon />
                        )}
                      </span>

                      <span
                        className={Styles.fileNameText}
                        style={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          maxWidth: "180px",
                        }}
                      >
                        {selectedFileNameFa || "Upload Final Agreement.pdf"}
                      </span>

                      {selectedFileNameFa && !isFinalAgreementDisabled && (
                        <span
                          onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            setSelectedFileNameFa("");
                            setSelectedFaFile(null);
                            setUploadedFaId(null);
                            document.getElementById("fileUploadFa").value = "";
                          }}
                          style={{ cursor: "pointer" }}
                          aria-label="Remove uploaded Final Agreement document"
                          role="button"
                          title="Remove"
                        >
                          <CrossIcon />
                        </span>
                      )}
                    </label>
                    <input
                      type="file"
                      id="fileUploadFa"
                      name="fileUploadFa"
                      accept=".pdf"
                      className={Styles.hiddenFileInput}
                      onChange={handleFileChange}
                      disabled={isFinalAgreementDisabled}
                    />
                  </span>
                </div>

                {/* --- Other Documents Section --- */}
                <div className={Styles.loiSection}>
                  <span>Other Documents</span>
                  <span>
                    <label
                      htmlFor="fileUploadOther"
                      className={`${Styles.customUploadBox}`}
                      style={{
                        pointerEvents: "auto",
                        opacity: 1,
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <span
                        style={{
                          cursor: "pointer",
                        }}
                        onClick={(e) => {
                          e.preventDefault();
                          if (!isOtherDocumentsDisabled) {
                            if (selectedFileNameOther) {
                              handleViewOtherDoc();
                            } else {
                              document
                                .getElementById("fileUploadOther")
                                ?.click();
                            }
                          }
                        }}
                        aria-label={
                          selectedFileNameOther && isOtherDocumentsDisabled
                            ? "View uploaded Other document"
                            : isOtherDocumentsDisabled
                              ? "Upload Other document"
                              : ""
                        }
                        role={!isOtherDocumentsDisabled ? "button" : undefined}
                      >
                        {selectedFileNameOther ? (
                          <ViewUploadFile />
                        ) : (
                          <UploadIcon />
                        )}
                      </span>

                      <span
                        className={Styles.fileNameText}
                        style={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          maxWidth: "200px",
                        }}
                      >
                        {selectedFileNameOther || "Upload Other Document.pdf"}
                      </span>

                      {selectedFileNameOther && !isOtherDocumentsDisabled && (
                        <span
                          onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            setSelectedFileNameOther("");
                            setSelectedOtherFile(null);
                            setUploadedOtherId(null);
                            setComments("");
                            document.getElementById("fileUploadOther").value =
                              "";
                          }}
                          style={{ cursor: "pointer" }}
                          aria-label="Remove uploaded Other document"
                          role="button"
                          title="Remove"
                        >
                          <CrossIcon />
                        </span>
                      )}
                    </label>
                    <input
                      type="file"
                      id="fileUploadOther"
                      name="fileUploadOther"
                      accept=".pdf"
                      className={Styles.hiddenFileInput}
                      onChange={handleFileChange}
                      // disabled={isOtherDocumentsDisabled}
                    />
                  </span>
                </div>
              </div>
            )}

            {/* --- Other Documents Section --- */}

            {/* --- Upload History Section --- */}
            <div className={Styles.uploadFilesContDoc}>
              <div className={Styles.docHistoryCont}>
                <div className={Styles.uploadHistoryContainer}>
                  <span>Upload History</span>
                </div>
                {loading ? (
                  <div>Loading...</div>
                ) : error ? (
                  <div style={{ color: "red" }}>Failed to load history.</div>
                ) : Array.isArray(documentViewHistory) &&
                  documentViewHistory?.length > 0 ? (
                  <div className={`scroll_bar_y ${Styles.uploadTableContent}`}>
                    {(() => {
                      const filterDocuments = (documents) => {
                        if (!documents || documents.length === 0) {
                          return [];
                        }

                        const finalResultMap = new Map();
                        const documentsToFilter = ["LOA", "LOI"];

                        for (const doc of documents) {
                          const agreementExists = documents.some(
                            (d) =>
                              d.filename === doc.filename &&
                              d.documentType === "AGREEMENT",
                          );

                          if (
                            agreementExists &&
                            documentsToFilter.includes(doc.documentType)
                          ) {
                            continue;
                          }
                          finalResultMap.set(doc.id, doc);
                        }

                        return Array.from(finalResultMap.values());
                      };

                      const filteredDocumentHistory =
                        filterDocuments(documentViewHistory);

                      return filteredDocumentHistory.map((doc) => {
                        const dateObj = doc.createdAt
                          ? new Date(doc.createdAt)
                          : null;

                        const datePart = dateObj
                          ? dateObj.toLocaleDateString("en-GB", {
                              day: "2-digit",
                              month: "short",
                              year: "2-digit",
                            })
                          : // .toUpperCase()
                            "";

                        const timePart = dateObj
                          ? dateObj.toLocaleTimeString("en-GB", {
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: false,
                            })
                          : "";

                        const getDocumentTypeName = (docType) => {
                          switch (docType?.toUpperCase()) {
                            case "LOI":
                              return (
                                <span
                                  style={{ fontWeight: 700, color: "#525062" }}
                                >
                                  LOI -{" "}
                                </span>
                              );
                            case "LOA":
                              return (
                                <span
                                  style={{ fontWeight: 700, color: "#525062" }}
                                >
                                  LOA -{" "}
                                </span>
                              );
                            case "AGREEMENT":
                            case "FA":
                              return (
                                <span
                                  style={{ fontWeight: 700, color: "#525062" }}
                                >
                                  Final Agreement -{" "}
                                </span>
                              );
                            case "RANDOM":
                            case "OTHER":
                              return (
                                <span
                                  style={{ fontWeight: 700, color: "#525062" }}
                                >
                                  Other Document -{" "}
                                </span>
                              );
                            default:
                              return "";
                          }
                        };

                        const getDocumentComment = (doc) => {
                          if (!doc) return "";
                          return (
                            doc.comment ||
                            doc.comments ||
                            doc.commentText ||
                            doc.note ||
                            ""
                          );
                        };

                        return (
                          <div
                            key={doc.id}
                            className={Styles.uploadTableHeader}
                          >
                            <div className={Styles.uploadFileName}>
                              {/* <span
                                style={{
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  maxWidth: "250px",
                                }}
                                title={`${getDocumentTypeName(
                                  doc.documentType
                                )}${doc.filename || "Untitled Document"}`}
                              >
                                {doc.companyName || "Untitled Document"}
                              </span> */}
                              <span style={{ paddingRight: "10px" }}>
                                {doc.companyName || "Untitled Document"}
                              </span>
                              <span
                                style={{
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  maxWidth: "500px",
                                  fontSize: "12px",
                                }}
                                title={`${getDocumentTypeName(
                                  doc.documentType,
                                )}${doc.filename || "Untitled Document"}`}
                              >
                                {getDocumentTypeName(doc.documentType)}
                                {doc.filename || "Untitled Document"}
                              </span>
                              <span
                                style={{
                                  width: "100%",
                                  color: "var(--color-text-inactive)",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  maxWidth: "200px",
                                }}
                                title={getDocumentComment(doc)}
                              >
                                {getDocumentComment(doc)}
                              </span>
                            </div>

                            <div className={Styles.uploadDateOther}>
                              <div>{datePart}</div>
                              <div>{timePart}</div>
                              <div
                                type="button"
                                onClick={() => handleViewDoc(doc.id)}
                                aria-label={`View document ${doc.filename}`}
                              >
                                <ViewIcon style={{ fontSize: "12px" }} />
                              </div>
                              <div
                                type="button"
                                onClick={() =>
                                  handleDownloadDocument(doc.id, doc.filename)
                                }
                                aria-label={`Download document ${doc.filename}`}
                                style={{ cursor: "pointer", marginLeft: "8px" }}
                              >
                                <DownloadIcon
                                  fontSize="small"
                                  style={{ width: "20px", height: "20px" }}
                                />
                              </div>
                            </div>
                          </div>
                        );
                      });
                    })()}
                  </div>
                ) : (
                  <div className={Styles.docViewSection}>
                    <div>No documents uploaded yet.</div>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* 3. Approval/Rejection Buttons (Conditional, at bottom) */}
          {showApprovalButtons ? (
            <div className={Styles.approvalButtons}>
              <div
                className={Styles.rejectButton}
                onClick={handleRejectClick}
                disabled={approvalLoading}
              >
                {approvalLoading ? "Processing..." : "Reject"}
              </div>
              <div
                className={`primary-button ${Styles.approveButton}`}
                onClick={handleApproveClick}
                disabled={approvalLoading}
              >
                {approvalLoading ? "Processing..." : "Proceed"}
              </div>
            </div>
          ) : (
            <div className={` ${Styles.approvalButtons}`}>
              <div
                className={`primary-button ${Styles.approveButton}`}
                onClick={() =>
                  setConfirmModal({
                    value: true,
                    type: "DIRECT_SUBMIT",
                    data: hasUploadedAnyDocument
                      ? "Your document will be submitted to the counterparty as the Final Agreement for their approval and execution. Do you want to proceed?"
                      : "You have not uploaded any document. Your submission will proceed to the counterparty as the Final Agreement for their approval and execution. Do you want to proceed?",
                    header: "Submit for Approval",
                  })
                }
                style={{
                  opacity: uploading ? 0.6 : 1,
                  pointerEvents: uploading ? "none" : "auto",
                }}
              >
                <span style={{ fontSize: "12px" }}>
                  {" "}
                  {uploading ? "Processing..." : "Submit "}
                </span>
              </div>
            </div>
          )}
        </div>
      </Modal>

      {/* <ConfirmationModal
        open={confirmationModalOpen}
        handleClose={() => setConfirmationModalOpen(false)}
        header="Approve Agreement"
        data="Do you want to approve this agreement?"
        note={
          isCounterparty
            ? hasCounterpartyUploadedDoc
              ? "Once approved, this listing will move to the ledger, and the connection will be finalized."
              : "**You have not uploaded any document.** Once approved, this listing will move to the ledger, and the connection will be finalized."
            : "Once approved, this listing will move to the ledger, and the connection will be finalized. Please ensure at least one document has been uploaded before proceeding."
        }
        handleSubmit={handleConfirmApproval}
        loading={approvalLoading}
        customStyle={{ height: "200px" }}
      /> */}

      <ConfirmationModal
        open={confirmationModalOpen}
        handleClose={() => setConfirmationModalOpen(false)}
        header="Approve Agreement"
        data={
          hasUploadedAnyDocument
            ? "Once approved, this listing will move to the ledger, and the connection will be finalized. \n\nPlease ensure that you have uploaded the countersigned document."
            : "You have not uploaded any document. Once approved, this listing will move to the ledger, and the connection will be finalized."
        }
        handleSubmit={handleConfirmApproval}
        loading={approvalLoading}
        customStyle={{ height: "200px" }}
        note={
          hasUploadedAnyDocument &&
          "If you've made any changes to the final document, please share it with the other party via chat for approval."
        }
      />
      <ConfirmationModal
        open={rejectionModalOpen}
        handleClose={() => setRejectionModalOpen(false)}
        header="Reject Agreement"
        data="Do you want to reject this agreement?"
        note="After rejecting the agreement, you may either wait for the counterparty to upload a revised version or upload a new version yourself."
        handleSubmit={handleConfirmRejection}
        loading={approvalLoading}
        customStyle={{ height: "200px" }}
      />

      {confirmModal?.value && (
        <ConfirmationModal
          open={true}
          handleClose={() => {
            // Clear the selected file based on type when user clicks NO
            if (confirmModal.type === "LOI") {
              setSelectedFileName("");
              setSelectedLoiFile(null);
              const input = document.getElementById("fileUpload");
              if (input) input.value = "";
            } else if (confirmModal.type === "LOA") {
              setSelectedFileNameLoa("");
              setSelectedLoaFile(null);
              const input = document.getElementById("fileUploadLoa");
              if (input) input.value = "";
            } else if (confirmModal.type === "FA") {
              setSelectedFileNameFa("");
              setSelectedFaFile(null);
              setFinalAgreementError("");
              const input = document.getElementById("fileUploadFa");
              if (input) input.value = "";
            } else if (confirmModal.type === "OTHER") {
              setSelectedFileNameOther("");
              setSelectedOtherFile(null);
              setComments("");
              const input = document.getElementById("fileUploadOther");
              if (input) input.value = "";
            }

            // Reset the modal state
            setConfirmModal({
              value: false,
              type: "",
              data: "",
              header: "",
            });
          }}
          header={confirmModal.header}
          data={confirmModal.data}
          commentBox={confirmModal.type === "OTHER"}
          commentBoxHeading={"Comments"}
          handleCommentChange={handleCommentsChange}
          handleSubmit={(comment) =>
            confirmModal.type === "OTHER"
              ? handleOtherDocument(false, comment)
              : confirmModal.type === "DIRECT_SUBMIT"
                ? handleDirectSubmit()
                : confirmModal.type === "FA"
                  ? handleFaConfirm()
                  : confirmModal.type === "LOI"
                    ? handleLoiConfirm()
                    : handleLoaConfirm()
          }
          loading={uploading || approvalLoading}
          customStyle={{ height: "200px" }}
          note={
            showApprovalButtons &&
            "If you’ve made any changes to the final document, please share it with the other party via chat for approval."
          }
        />
      )}

      <PreviewModal
        open={previewModal}
        onClose={handleClosePreview}
        fileUrl={previewFileUrl}
        documentId={previewDocumentId}
      />
    </>
  );
};

export default UploadDocModal;
